import clsx from "clsx";

interface DividerProps {
  variant?: "horizontal" | "vertical";
  theme?: "light" | "dark";
}

export function Divider({ variant = "horizontal", theme = "dark" }: DividerProps) {
  const borderColor = theme === "dark" ? "border-[#FFFFFF]" : "border-[#E0E8F6]";

  if (variant === "horizontal") {
    return <hr className={clsx("my-8 w-full border-t", borderColor)} />;
  }

  return <div className={clsx("border-l mx-8 self-stretch", borderColor)} />;
}